import { Typography } from '@mui/material';
import { _ } from '/@/locale';

type NamedUser =
    | {
          name?: string | null;
          user?: { firstName?: string | null; lastName?: string | null } | null;
      }
    | null
    | undefined;

/**
 * Builds a display name from a user-node-like object: prefer its `name`, otherwise join
 * the user's first + last name. Returns `''` when nothing is available (so callers can
 * fall back to a generic "Registrado" label).
 */
export const getUserDisplayName = (source: NamedUser): string => {
    if (!source) return '';
    if (source.name) return source.name;
    return [source.user?.firstName, source.user?.lastName].filter(Boolean).join(' ').trim();
};

/** "Registrado por {author} - {date}" caption shared by the registry cards. */
export const RegistryFooter = ({ authorName, date }: { authorName?: string; date: string }) => (
    <Typography variant='caption' color='primary.mui.inactive'>
        {authorName ? `${_('Registrado por')} ${authorName} - ${date}` : `${_('Registrado')} - ${date}`}
    </Typography>
);
